import React from 'react'
import { Helmet } from 'react-helmet';
import {FAQItem} from './FAQItem';

function MenuPreguntas() {
    return (
        <div className="contentLeft">
          <Helmet>
            <title>Preguntas Frecuentes - MarketBiz.ai</title>
            <meta
              name="description"
              content="Resuelve tus dudas sobre MarketBiz.ai: funciones, seguridad, planes y cómo nuestra inteligencia artificial te ayuda en licitaciones."
            />
            <link rel="canonical" href="https://www.marketbiz.ai/Preguntas%20Frecuentes" />
          </Helmet>

          <h1 style={{width: '100%', minWidth: '1300'}}>Preguntas Frecuentes</h1>

          {/*--------------------*/}
            <FAQItem question="1. ¿Qué es MarketBiz.ai?">
              <p>MarketBiz.ai es una plataforma de inteligencia artificial diseñada para analizar y gestionar documentos de licitación. Nuestra herramienta automatiza los procesos más complejos, ayudándote a ahorrar tiempo y mejorar tu precisión al participar en licitaciones públicas o privadas.</p>
            </FAQItem>
            <FAQItem question="2. ¿Qué funciones están disponibles actualmente?">
              <p>Actualmente, MarketBiz.ai ofrece tres herramientas clave:</p>
              <ul className="custom-bullets">
                <li>Lectura Express: Resumen rápido de los puntos clave del documento.</li>
                <li>Lectura Completa: Análisis detallado de requisitos jurídicos, financieros y técnicos.</li>
                <li>Lectura Personalizada: Verificación del cumplimiento de requisitos financieros y experiencia usando tu RUP (Registro Único de Proponentes).</li>
              </ul>
            </FAQItem>
            <FAQItem question="3. ¿Puedo usar MarketBiz.ai de forma gratuita?">
              <p>Sí, ofrecemos un plan Free que te permite acceder a la funcionalidad Lectura Express con ciertas limitaciones. Es ideal para que pruebes la plataforma antes de optar por un plan pago.</p>
            </FAQItem>
            <FAQItem question="4. ¿Cómo funciona la Lectura Personalizada?">
              <p>La Lectura Personalizada permite cargar tu RUP (Registro Único de Proponentes). Usamos esa información para verificar automáticamente si cumples con los requisitos financieros y de experiencia que solicita la licitación, incluyendo análisis bajo el código UNSPSC en Colombia.</p>
            </FAQItem>
            <FAQItem question="5. ¿Qué diferencia hay entre los planes Free, Plata y Oro?">
              <ul className="custom-bullets">
                <li>Free: Acceso limitado a la Lectura Express.</li>
                <li>Plata: Incluye Lectura Express ilimitada y acceso a Lectura Completa.</li>
                <li>Oro: Añade Lectura Personalizada para un análisis profundo basado en el RUP, además de todo lo incluido en Plata.</li>
              </ul>
            </FAQItem>
            <FAQItem question="6. ¿Mi información está segura en MarketBiz.ai?">
              <p>Sí, la seguridad de tus datos es nuestra prioridad. Utilizamos tecnología de encriptación avanzada para proteger toda la información que subes a la plataforma, asegurando la confidencialidad de tus documentos.</p>
            </FAQItem>
            <FAQItem question="7. ¿Qué pasa si tengo dudas o problemas?">
              <p>Nuestro equipo de soporte está listo para ayudarte. Si tienes alguna pregunta o problema, puedes contactarnos a través de nuestra sección de Contacto, y responderemos lo más rápido posible.</p>
            </FAQItem>
            <FAQItem question="8. ¿MarketBiz.ai es útil para empresas de cualquier tamaño?">
            <p>Absolutamente. MarketBiz.ai es flexible y se adapta tanto a emprendedores como a grandes corporaciones. Ofrecemos herramientas que optimizan el tiempo y esfuerzo de cualquier equipo.</p>
            </FAQItem>
          
          {/*--------------------*/}
          <h2 
            className="subtitulo" 
            style={{
              color: 'transparent', 
              textShadow: 'none',  // Elimina cualquier sombra si es que la hubiera
              border: 'none',      // Elimina los bordes si existieran
            }}
          >
            Transformando la accesibilidad y sostenibilidad en licitaciones con AI.
          </h2>
        </div>
    );
}

export default MenuPreguntas;